import HttpService from "./HttpService";
const API_URL = "/employee-duty-type";

const DutyTypeService = {
  fetch: async () => {
    try {
      const response = await HttpService.get(`${API_URL}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching duty types:", error);
      throw error;
    }
  },
  fetchPaginated: async (pageConfig) => {
    const pageConfigParams =  new URLSearchParams(pageConfig);
    try {
      const response = await HttpService.get(`${API_URL}-paginated?${pageConfigParams}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching duty types:", error);
      throw error;
    }
  },
  fetchFullTimeDuty: async () => {
    try {
      const response = await HttpService.get("/full-time-duty");
      return response.data;
    } catch (error) {
      console.error("Error fetching duty type:", error);
      throw error;
    }
  },
  fetchPartTimeDuty: async () => {
    try {
      const response = await HttpService.get("/part-time-duty");
      return response.data;
    } catch (error) {
      console.error("Error fetching duty type:", error);
      throw error;
    }
  },
  fetchContractualDuty: async () => {
    try {
      const response = await HttpService.get("/contract-time-duty");
      return response.data;
    } catch (error) {
      console.error("Error fetching duty type:", error);
      throw error;
    }
  },
  fetchProbationaryDuty: async () => {
    try {
      const response = await HttpService.get("/probation-duty");
      return response.data;
    } catch (error) {
      console.error("Error fetching duty type:", error);
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await HttpService.post(API_URL, data);
      return response.data;
    } catch (error) {
      console.error("Error adding duty type:", error);
      throw error;
    }
  },

  edit: async (id) => {
    try {
      const response = await HttpService.get(`${API_URL}/${id}/edit`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, updatedData) => {
    // data["_method"] = "PUT";
    try {
      const response = await HttpService.put(`${API_URL}/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating duty type:", error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await HttpService.delete(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting duty type:", error);
      throw error;
    }
  },
};

export default DutyTypeService;
